import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux"
import { State } from "../../../../reducers"
import { ModalBase } from "../../../../components/Modals/ModalBase"
import '../styles/lista-usuario.css'
import PrintSchemaV3 from "../../../../components/Print/print-view"
import { useReactToPrint } from 'react-to-print';



export const ModalPrint = (props: any) => {
    const {tipoDocumento} = useSelector((state: State) => state.catalogos)
    const componentRef = useRef(null);
    const divRef = useRef<HTMLDivElement>(null);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    })

    return (
        <ModalBase>
            <div className='modal-card'>
                <div className='modal-content'>
                    <div className='w-layout-hflex'>
                        <h3 className='card-title l'>IMPRIMIR</h3>
                    </div>
                    <div className='form-separator'></div>
                    <p>
                        ¿Deseas imprimir la información de este usuario?
                    </p>
                    <div  style={{display:'none'}}>
                        <PrintSchemaV3 ref={componentRef} dataPrint={divRef?.current?.innerHTML || ''} />
                    </div>
                    <div className='pdf-container' ref={divRef}>
                        <label>FICHA DE USUARIO</label>
                        <div style={{display: 'flex', flexDirection: 'column' , justifyContent: 'center'}} className="ficha-container">
                            <h3>{`${props.dataCliente.empresa} - ${props.dataCliente.first_name || ''} ${props.dataCliente.last_name || ''}`}</h3>
                            <label>{props.dataCliente.codigo_empresa || ''}</label>
                            <table className="table-ficha-cliente">
                                <tbody>
                                    <tr>
                                        <td>Nombre de usuario </td>
                                        <td>{`${props.dataCliente.username || ''}`.trim()}</td>
                                    </tr>
                                    <tr>
                                        <td>Nombre completo </td>
                                        <td>{`${props.dataCliente.first_name || ''} ${props.dataCliente.second_name || ''} ${props.dataCliente.third_name || ''} ${props.dataCliente.last_name || ''} ${props.dataCliente.last_name2 || ''} ${props.dataCliente.last_name_married || ''}`.trim()}</td>
                                    </tr>
                                    <tr>
                                        <td>Teléfono celular </td>
                                        <td>{`+${props?.dataCliente?.phone_number}`}</td>
                                    </tr>
                                    <tr>
                                        <td>Correo electrónico </td>
                                        <td>{`${props.dataCliente.email || ''}`.trim()}</td>
                                    </tr>
                                    <tr>
                                        <td>Dirección</td>
                                        <td>{props.dataCliente.location || ''}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha de Nacimiento</td>
                                        <td>{new Date(props.dataCliente.birth_date).toLocaleDateString() || ''}</td>
                                    </tr>
                                    <tr>
                                        <td>Tipo de documento de identificación</td>
                                        <td>{tipoDocumento.find((doc) => doc.codigo === props.dataCliente.type_id_number)?.valor  || ''}</td>
                                    </tr>
                                    <tr>
                                        <td>No. Documento de Identificación </td>
                                        <td>{props.dataCliente.id_number || ''}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5 style={{color:'#000'}}>Sucursales</h5>
                            <table className="table-sucursales">
                                <thead>
                                    <tr>
                                        <th>Nombre</th> 
                                        <th>Dirección</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                      (props.dataCliente.sucursales?.length > 0) ? 
                                      ( 
                                        props.dataCliente.sucursales
                                          .filter((sucu: any) => sucu?.estado === "ACTIVO")
                                          .map((sucursal: any) => (
                                            <tr>
                                              <td>{sucursal?.Sucursal?.nombre}</td>
                                              <td>{sucursal?.Sucursal?.direccion}</td>
                                            </tr>
                                        ))
                                      )
                                      : 
                                      (
                                        <tr>
                                          <td colSpan={2} style={{padding: '10px'}}>Sin sucursales asignadas</td>
                                        </tr>
                                      )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='form-separator'></div>
                    <div className='w-layout-hflex button-actions'>
                        <button
                            className='m button transparent w-inline-block'
                            onClick={props.closeModalPrint}
                        >
                            <div>Cancelar</div>
                        </button>
                        <button
                            className='m button w-inline-block'
                            onClick={handlePrint}
                        >
                            <div>Imprimir <img/></div>
                        </button>
                        <button
                            className='m button w-inline-block'
                            onClick={props.actionConfirm}
                        >
                            <div>Descargar <img/></div>
                        </button>
                    </div>
                </div>
            </div>
        </ModalBase>
    )
}